<script setup>
import { ref, computed, reactive } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useRequestsStore } from '@/stores/storeRequests';
import SertHeader from '@/components/blocks/SertHeader.vue';
import BaseInput from '@/components/ui/BaseInput.vue';

const storeSert = useSertStore();
const storeRequests = useRequestsStore();

const nextSreen = async () => {
    const response = await storeRequests.userInfoChnage();
    if(!response?.success) return;
    storeSert.goToScreen(storeSert.screens.design)  
    history.pushState(null, "", `#${storeSert.screens.design}`)
};

const previousSreen = () => {
    storeSert.goToScreen(storeSert.screens.authSms)
    history.pushState(null, "", `#${storeSert.screens.authSms}`)
    storeRequests.responseError = null
}


</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="3">
                <template #title>Уточнение данных</template>
                <template #text></template>
            </SertHeader>            
            <div class="form --form-pay">
                <div class="form__row --two-col">
                    <BaseInput 
                        type="text" 
                        placeholder="Имя"
                        state-key="firstName" 
                        :required="true"
                    >
                        Ваше имя
                    </BaseInput>
                    <BaseInput 
                        type="text" 
                        placeholder="Фамилия"
                        state-key="lastName"                         
                    >
                        Фамилия
                    </BaseInput>
                </div>
                
                <div :class="['form__row', ]">
                    <BaseInput 
                        type="date" 
                        placeholder="Дата рождения"
                        state-key="birthday" 
                    >
                    Дата рождения
                    </BaseInput>
                </div>
                <div :class="['form__row', ]">
                    <BaseInput 
                        type="text" 
                        placeholder="email@ya.ru"
                        state-key="email"
                        :required="true" 
                    >
                        Email
                    </BaseInput>
                </div>                
                
            </div>
        </div>
        <div class="constructor__btns-inner">
            <p class="text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
            <div class="constructor__btns">
                <button class="btn --black" @click="previousSreen">
                    <span>Назад</span>
                </button>
                <button :disabled="storeSert.isBtnDisabled(['firstName', 'email'])" class="btn --full" @click="nextSreen">
                    <span v-if="!storeRequests.loaderBtn">Далее</span>
                    <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                </button>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>